import { SystemIconType, L1IconType } from '@fiverr-private/visuals';
import { LoaderSizes } from './types';

export const SYSTEM_SIZE_MAP: Record<Extract<LoaderSizes, 'sm' | 'md'>, SystemIconType['size']> = {
    sm: 'sm',
    md: 'md',
};

export const L1_SIZE_MAP: Record<Extract<LoaderSizes, 'lg' | 'xl'>, L1IconType['size']> = {
    lg: 'sm',
    xl: 'md',
};
